import React from 'react';

const SvgIcon = ({ 
  src, 
  color = '#666', 
  hoverColor = '#6e41c1', 
  size = '12px',
  className = '',
  style = {},
  ...props 
}) => {
  const [isHovered, setIsHovered] = React.useState(false);
  
  const iconStyle = {
    width: size,
    height: size,
    color: isHovered ? hoverColor : color,
    transition: 'color 0.2s ease',
    display: 'inline-block',
    lineHeight: 0,
    ...style
  };

  return (
    <span
      className={`svg-icon ${className}`}
      style={iconStyle}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      {...props}
    >
      {typeof src === 'string' ? (
        <img 
          src={src} 
          alt=''
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain'
          }}
        />
      ) : src}
    </span>
  );
};

export default SvgIcon;


